/**
 * Shared API endpoint paths — these are relative paths appended to apiProxyUrl.
 * Same across all environments.
 */
export const apiUrls = {
  CSRF: 'csrf',
  ExecutiveSummaryPath: 'providersystems',
  ProviderSystemClaimsAgg: 'agg-claims/search/v2.0/',
  ProviderSystemClaimsSummary: 'claim-metrics/',
  ProviderSystemPriorAuth: 'PriorAuthSummary/',
  SsoTokenPath: 'myinsightOptumIdHandshake',
  LayerSevenPath: 'myinsightLayerSevenHandshake',
  InternalPingFederate: 'api/auth/login',
  InternalAccessTokenCallback: 'api/auth/callback',
  SsoFetchUserDetails: 'api/auth/fetchUserDetails',
  SsoTokenRefresh: 'api/auth/refresh',
  SsoTokenRevoke: 'api/auth/logout',
  OHIDLogin: 'api/auth/ohid/login',
  OHIDCallback: 'api/auth/ohid/callback',
  OHIDTokenRefresh: 'api/auth/ohid/refresh',
  OHIDTokenLogout: 'api/auth/ohid/logout',
  performanceExportS3url: 'bulk-exporter.s3.amazonaws.com',
  ProvTinList: 'provider-tins/',
  URL: window.location.origin,
  LogoutEvent: 'logoutevent/',
  LDAPAuth: 'ldapauth',
  AcoPath: 'aco-provider-metrics/',
  ProviderList: 'providers',
  Appeals: 'appeals/',
  PriorAuth: 'prior-authorizations/summary/',
  PriorAuthTAT: 'prior-authorizations/tat/',
  PriorAuthSubmissionDetails: 'prior-authorizations/submissiondetails/',
  PriorAuthReasons: 'prior-authorizations/topreasons/',
  PriorAuthSubmissionsOverTime: 'prior-authorizations/case-submission-trend/',
  PriorAuthCptCodes: 'prior-authorizations/cptCodes/',
  PriorAuthTopFilter: 'prior-authorizations/topfilter/',
  RepeatContact: 'repeat-contacts/search/',
  Calls: 'issue-resolutions/',
  CallsSummary: 'calls/summary',
  PaymentIntegrity: 'pi-metrics/',
  NonPayment: 'claim-metrics/',
  NonPaymentTopClaims: 'non-payment-claims/',
  NonPaymentDetails: 'claims-bifurcate-metrics/',
  NonPaymentTrend: 'claims-non-payment-monthly/',
  NonPaymentDop: 'dop-claim-metrics/',
  NonPaymentDopTrend: 'dop-denial-trends/',
  OverpaymentsTopReasons: 'claims-overturn-reason-metrics',
  CallsTrend: 'provider-calls/',
  TrendingMetrics: 'trending-metrics/',
  TopFilterUrl: 'standard-search/topfilter',
  PCORQualityMeasure: 'patient-care-metrics/',
  NPSSummary: 'kop-metrics/',
  NPSQuarterlySummary: 'kop-quarterly-metrics',
  KOPPriorAuthSummary: 'kop-priorauth-metrics/',
  KOPPriorAuthTATSummary: 'kop-priorauth-tat/',
  KOPReimbursementClaims: 'kop-reimbursement-metrics/',
  AppealsTrend: 'appeals-trend/',
  AdminSummaryTrends: 'admintrends/',
  AppealsFHIR: 'claims-appeals-metrics/',
  AppealsOverturn: 'appeal-overturn-reasons/',
  AdminSummaryTrendsCount: 'admintrendscount/',
  PocaStatus: 'poca-status/',
  PcmsFilter: 'pcms-master-metrics/',
  PcmsAMD: 'pcms-amd/',
  PerformanceFilter: 'network-measures-master-details/',
  PerformanceDateFilter: 'date-filter-source/NETWORKLEVER/',
  RefreshToken: 'getRefreshToken/',
  HealthSystemDetails: 'providerInfo/',
  CallsTrendLine: 'calls-trends/',
  PaymentsBySubmissionDOP: 'dop-claim-submissions/',
  PaymentsBySubmission: 'claim-submissions/',
  GroupPremiumDesignation: 'hpp-pilot-indicator/',
  NetworkLever: 'network-lever/',
  PaymentIntegrityTabsInfo: 'pi-tab-info/',
  NewPaymentIntegrity: 'payment-integrity/',
  ProviderSearch: 'provider-search',
  AdvocateTinDetails: 'advocate-tin-details/',
  SmartEdits: 'smart-edit-metrics/',
  SmartEditsTabDetails: 'smart-edits/summary',
  SmartEditsTopClaims: 'smart-edit-codes/',
  SmartEditsClaims: 'smart-edits/top-reasons',
  getPublicKey: 'getPublicKey',
  UserPreferences: 'user-preferences/',
  saveUserPreferences: 'save-user-preference/',
  ADMSystemLevel: 'adm-metrics/',
  ADMStateLevel: 'adm-state-details/',
  ADMDateFilter: 'date-filter-source/ADM',
  LOCDateFilter: 'date-filter-source/LOC',
  HRLDateFilter: 'date-filter-source/HRL',
  MetricDefinitions: 'metric-definitions/',
  MetricDataSources: 'metric-datasources/',
  SaveMetricDefinition: 'save-metric-definition/',
  PCMS_METRICS: 'pcms-metrics/',
  NpsSurveyMetrics: 'kop-nps-survey-metrics',
  pcmsSOT: 'pcms-sot/',
  pcmsAMD: 'pcms-amd/',
  LOCData: 'loc-metrics/',
  LOCHospitals: 'loc-hospitals/',
  SaveUserPreference: 'save-user-preference',
  NetworkLeverSummary: 'network-measure/summary/',
  NetworkLeverServiceDetails: 'network-measures-category-details/',
  NetworkLeverDetails: 'network-measures-details/',
  POCATins: 'poca/pa-tins/',
  GeoSegmentation: 'geo-segmentation/search',
  POCaActivatedTins: 'poca/activated-tins/',
  NetworkLeverTinDetails: 'network-measure/tin-details/',
  NetworkLeverPreferredDetails: 'network-measures-breakdown-details/',
  TransactionAndUsers: 'poca/users-info/',
  TransactionAndUsersAggreValues: 'poca/users-ytd-info/',
  POCAEMRIP: 'poca/emr-transactions/',
  CptCodeDetails: 'poca/cpt-details/',
  POCATransactionsResults: 'poca/result-categories/',
  affordabilityDDPMPINTable: 'affordability/program-details',
  POCAEligibilityTins: 'poca/eligibility-tins/',
  POCAEligibilityEMRIP: 'poca/eligibility-transactions-info/',
  POCAEligibilitySystems: 'poca/eligibility-systems/',
  pocaEligibilityTransactionsUsers: 'poca/eligibility-users-info/',
  ClaimsYieldByService: 'dos-claims-yield-metrics/',
  ClaimsYieldTotal: 'gross-yield-metrics/',
  TileConfig: 'provider-metrics-ids/',
  PASavingOpportunities: 'prior-authorizations/case-submission-by-channel/',
  PriorAuthQuickCodeNPIFilter: 'poca/pa-tins-npis/',
  claimYieldPassWise: 'claims-yield-pass-wise-metrics/',
  claimYeildPassServiceType: 'service-type-pass-wise-metrics/',
  FetchAllGroups: 'fetchAllGroups',
  DeleteGroup: 'deleteGroup',
  JourneyDetails: 'journey-details',
  SiteNotifications: 'site-notifications',
  SaveSiteNotification: 'save-site-notification',
  AppealsDetails: 'claims-appeals-summary',
  ClaimsAppealsTrend: 'claims-appeals-trend/',
  ClaimOverturnMetric: 'claims-overturn-metrics',
  ClaimMetrics: 'claim-metrics',
  benchmarkAverages: 'bench-mark-averages',
  NetworkMeasureExportDetails: 'network-measure-export-details',
  NetworkMeasureExportStatus: 'network-measure-export-status',
  NetworkMeasureExportDownloadLinks: 'network-measure-export-download-links',
  VbcProgramDetails: 'vbc/program-details',
  vbcPayoutsData: 'vbc/prior-year-payouts',
  VBCInflator: 'vbc/inflators',
  VbcIncentiveLob: 'vbc/incentive-program-details',
  smartEditTrendGraph: 'smart-edits/over-time',
  smartEditTopClaims: 'smart-edits/top-claims',
  topFiveList: 'provider-tin-search',
  saveTopFive: 'save-search-details',
  tinName: 'tin/getCorpOwners/',
  piEvaluations: 'evaluations/',
  PiAdjustments: 'evaluations-adjustments/',
  PiMedicalRecords: 'medical-records/',
  PiAuditReasons: 'audit-reason-details/',
  PIEvaluationDetails: 'evaluation-details/',
  PiClaimsDetails: 'medical-records-claim-details/',
  ExtendedTinDetails: 'extended-tins/top-filter?items=MULTITIN',
  ExtendedTinSelectedDetails: 'extended-tins/top-filter?items=TIN',
  GetProviderPreference: 'get-provider-preferences',
  SaveProviderPreference: 'save-provider-preferences',
  paymentsAllPassesMetrics: 'claims-yield-all-passes-metrics/',
};
